
import { get } from '@/libs/http';
import type { TransferPopupConfigReq, TransferPopupConfigRes } from '@/types/api/user/transfer-popup-config';

// 获取包转移配置
export const getTransferPackageInfo = (params: TransferPopupConfigReq) => {
  return get<TransferPopupConfigRes>('/user/v1/transferConfig', { params });
};